module.exports = __webpack_public_path__ + "static/media/primary.a334ffa0.gif";